
import * as XLSX from 'xlsx'
import type { Vote } from './types'

const HEADERS = [
  'Full Name',
  'Email',
  'Selected City',
  'Province',
  'Date',
  'Time',
  'Timestamp',
  'Timezone',
]

function toRows(votes: Vote[]): (string | undefined)[][] {
  return votes.map((v) => [
    v.fullName,
    v.email,
    v.city,
    v.province,
    v.date,
    v.time,
    v.timestamp,
    v.timezone,
  ])
}

export function exportCSV(votes: Vote[]) {
  const rows = [HEADERS, ...toRows(votes)]
  const csv = rows
    .map((r) =>
      r
        .map((cell) => {
          const s = cell ?? ''
          return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
        })
        .join(','),
    )
    .join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  triggerDownload(blob, `retreat-votes-${stamp()}.csv`)
}

export function exportExcel(votes: Vote[]) {
  const ws = XLSX.utils.aoa_to_sheet([HEADERS, ...toRows(votes)])
  ws['!cols'] = HEADERS.map(() => ({ wch: 20 }))
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Votes')
  XLSX.writeFile(wb, `retreat-votes-${stamp()}.xlsx`)
}

export function printResults() {
  window.print()
}

function stamp(): string {
  return new Date().toISOString().slice(0, 10)
}

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

